<template>
<div v-if="error" class="api-error-box">
   <span div data-toggle="tooltip" data-html="true" :title="error" @click="emitClick">
      <!-- <i class="fad fa-exclamation-circle fa-2x error-icon"></i> -->
      <i class="fad fa-times-circle fa-2x error-close"></i>
   </span>
   <div class="api-textbox">
      <div class="error-text">
         <div class="error-title">Sorry, something went wrong on our end.</div>
         <div class="error-subtitle">We are currenlty trying to fix the problem.</div>
      </div>
      <div class="error-choices">
         <div><i class="far fa-clock retry-icon"></i>Wait a few minutes</div>
         <div><i class="far fa-redo retry-icon"></i>Refresh the page</div>
      </div>
   </div>
</div>
</template>

<script>
   import { mapGetters, mapActions, mapState } from 'vuex'
   export default {
      props: {
         error: String,
      },
      methods: {
         emitClick(){
            this.$emit('errorClicked');
         },
      }
   }
</script>
